<template>
  <div class="o-reset-password">
    <MoleculeResetPassword/>
  </div>
</template>

<script>
export default {
  name: 'OrganismResetPassword',

  components: {
    MoleculeResetPassword: () => import('@/components/molecules/MoleculeResetPassword')
  }
}
</script>
